import { pageInfo} from './../api';
import { Message } from 'element-ui';
const toxinInspectVehicleManual = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateResp: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    }
  }
}
export default toxinInspectVehicleManual



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectVehicleManual/store/toxinInspectVehicleManual.store.js